import { usersArray } from "assets/data/usersData";
import { Link } from "react-router-dom";
import { Card, CardFilter, JoinedUser } from "ui";
const JoinedUsers = () => {
    return (
        <Card className="w-full h-full flex flex-col gap-5">
            <div className="flex flex-col justify-start items-start gap-2 dark:text-white">
                <h2 className="text-lg font-medium">Recently Joined Users</h2>
                <CardFilter
                    dropDownItems={[
                        "User ID",
                        "userName",
                        "Members Name",
                        "Country",
                        "Words"
                    ]}
                />
            </div>
            <div className="flex flex-col justify-start items-center gap-5 w-full h-full bg-neutral-50 dark:bg-momeento-100 rounded overflow-auto">
                {usersArray.map((u) => (
                    <JoinedUser user={u} key={u.id} />
                ))}
            </div>
            <div className="w-full text-center">
                <Link
                    to="/users"
                    className="w-fit px-5 py-2 text-sm text-center bg-momeento-50 text-white hover:shadow-xl rounded-full"
                >
                    View More...
                </Link>
            </div>
        </Card>
    );
};
export default JoinedUsers;
